import React, { useMemo } from "react";
import styled from "styled-components";
import { getCountryLabel, getSortedCountries } from "./countries";

const CountrySelect = ({
  value,
  onChange,
  lang,
  label,
  placeholder,
  name = "country_code",
  required = false,
}) => {
  const countries = useMemo(() => getSortedCountries(lang), [lang]);

  return (
    <Field>
      <Label htmlFor={name}>{label}{required ? " *" : ""}</Label>
      <Select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        autoComplete="country"
        required={required}
      >
        <option value="">{placeholder}</option>
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            {getCountryLabel(country.code, lang)}
          </option>
        ))}
      </Select>
    </Field>
  );
};

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const Label = styled.label`
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(0,0,0,0.45);
`;

const Select = styled.select`
  background: #f8f8f8;
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 6px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  color: #111;
  transition: border-color 0.2s, background 0.2s;
  outline: none;

  &:invalid { color: rgba(0,0,0,0.45); }

  &:focus {
    border-color: #4CAF50;
    background: #fff;
  }
`;

export default CountrySelect;
